import React, { useEffect, useRef } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledServicesSection = styled.section`
  max-width: 1000px;

  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 15px;
    margin-top: 40px;
  }
`;

const StyledCard = styled.div`
  ${({ theme }) => theme.mixins.boxShadow};
  background-color: var(--light-navy);
  border-radius: var(--border-radius);
  padding: 1.75rem;

  h3 {
    margin: 0 0 10px;
    color: var(--lightest-slate);
    font-size: var(--fz-xl);
  }

  .desc {
    color: var(--light-slate);
    font-size: 17px;
    line-height: 1.6;
  }
`;

const Services = () => {
  const data = useStaticQuery(graphql`
    query {
      services: allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/content/user/services/" } }
        sort: { fields: [frontmatter___order, frontmatter___title], order: ASC }
      ) {
        edges {
          node {
            frontmatter {
              title
              order
            }
            html
          }
        }
      }
    }
  `);

  const services = data.services.edges.filter(({ node }) => node);
  if (!services || services.length === 0) {
    return null;
  }

  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledServicesSection id="services" ref={revealContainer}>
      <h2 className="numbered-heading">What I Do</h2>

      <div className="grid">
        {services.map(({ node }, i) => {
          const { title } = node.frontmatter;
          return (
            <StyledCard key={i}>
              <h3>{title}</h3>
              <div className="desc" dangerouslySetInnerHTML={{ __html: node.html }} />
            </StyledCard>
          );
        })}
      </div>
    </StyledServicesSection>
  );
};

export default Services;
